export const sizes = {
  mobile: '320px',
  tablet: '768px',
  desktop: '1024px',
  videowall: '20000px'
}

export const deviceValue = {
  mobile: 320,
  tablet: 768,
  desktop: 1024,
  videowall: 20000
}

export const devices = {
  mobile: `(min-width: ${sizes.mobile})`,
  tablet: `(min-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
  videowall: `(min-width: ${sizes.videowall})`
};